import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { AiActionsSection } from "./AiActionsSection";
import { AiFiltersSection } from "./AiFiltersSection";

interface LeftSideProps {
  handleActivate: () => void;
  handleLearnMore: () => void;
}

export const LeftSide = ({
  handleActivate,
  handleLearnMore,
}: LeftSideProps) => (
  <div className="flex flex-1 flex-col">
    <AiFiltersSection />
    <AiActionsSection />
    <div className="mt-auto flex flex-col gap-4">
      <Button onClick={handleActivate} large full variant="circle">
        {t("settings.ai_actions.modal.activate_button")}
      </Button>
      <Button onClick={handleLearnMore} large full variant="secondary">
        {t("settings.ai_actions.modal.learn_more_button")}
      </Button>
    </div>
  </div>
);
